import Echo from "laravel-echo";

window.io = require("socket.io-client");

var EchoInstance = (function () {
  var instance;
  var isUser;

  function createInstance(type) {
      let object = new Echo({
        broadcaster: "socket.io",
        host: process.env.VUE_APP_BACKEND_SOCKET,
      });
      if (type == 'user') {
        isUser = true;
      }
      return object;
  }

  return {
      getInstance: function (type) {
          //if (type=='new' || !instance) {
          if (!isUser) {
              instance = createInstance(type);
          }
          //}
          return instance;
      }
  };
})();

export default EchoInstance;